import { Link } from 'react-router-dom'

export default function NotFound() {
  return (
    <main className="page">
      <div className="container center" style={{ padding: '60px 0' }}>
        <div style={{ fontSize: '3rem', marginBottom: 10 }}>🧭</div>
        <h1 className="section-title">Page not found</h1>
        <p className="section-sub">The page you're looking for doesn't exist.</p>
        <Link to="/" className="btn btn-primary">Back home</Link>
      </div>
    </main>
  )
}
